//
// Class representing an auction
function AdsNinjaBidsPool(id){

    // Constants.
    this.TIME_TO_LIVE_BUFFER                    = 10;                     // Abbreviated TTL.
    this.INDEX_VALNET_USED                      = 'valnetUsed';
    this.INDEX_VALNET_EXPIRED                   = 'valnetExpired';
    this.INDEX_VALNET_INVALIDATED               = 'valnetInvalidated';
    this.INDEX_VALNET_SENT_CURRENTLY            = 'valnetSentCurrently';
    this.INDEX_VALNET_SENT_NUMBER_OF_TIMES      = 'valnetSentNumberOfTimes';
    this.INDEX_VALNET_FROM_AUCTION              = 'valnetFromAuction';
    this.INDEX_VALNET_BLACKLISTED               = 'valnetBlacklisted';
    this.INDEX_VALNET_BELONG_TO_LAST_AUCTION    = 'valnetBelongToLastAuction';
    this.BIDDING_LIBRARY_AMAZON                 = 'amazon';
    this.BIDDING_LIBRARY_PREBID                 = 'prebid';

    this.BIDDING_LIBRARIES                      = [ // TODO: Check.
        this.BIDDING_LIBRARY_AMAZON,
        this.BIDDING_LIBRARY_PREBID,
    ];

    this.TRACKED_DEALS                          = [
        "2212428",
        "2265248",
        "2265251",
        "2268396",
        "2268398",
        "2269878",
        "2269892",
        "opath-326-1629-fl7pq0ut2p",
        "opath-326-1629-sfg40magm7",
        "opath-326-2158-clgtkb8u6t",
        "opath-326-2158-zp9kpu1e3",
        "opath-326-2965-kfjva6xg8b",
        "opath-326-2965-9z4b1b1xbb",
        "opath-326-2965-yof0qxyc5n",
        "IX773418041159881499",
        "3846737",
    ];

    this.__id                                = id;
    this.__bidPoolPrebid                     = []; // TODO: Use this for video bids.
    this.__bidPoolAmazon                     = [];
    this.__logger                            = new AdsNinjaLogger();
    this.validAdSizes                        = [];

}

AdsNinjaBidsPool.prototype.getId = function(){

    return this.__id;
};



//
// __logger
AdsNinjaBidsPool.prototype.setLogger = function(value){

    this.__logger = value;
};



//
// Set Amazon bids.
AdsNinjaBidsPool.prototype.addBidsAmazon = function(bid){

    if(!bid || bid.length === 0){

        return;
    }

    var combinedBids = this.__bidPoolAmazon.concat(bid);
    var sortedBids   = Object.values(combinedBids).sort(function(bidA, bidB){

        return Math.round(1000 * bidB.cpm) - Math.round(1000 * bidA.cpm);
    });

    // Add additional fields.
    for(var x in sortedBids){

        sortedBids[x][this.INDEX_VALNET_BELONG_TO_LAST_AUCTION] = false;

        // Only add these fields to new bids.
        if(sortedBids[x].hasOwnProperty(this.INDEX_VALNET_USED)){

            continue;
        }

        sortedBids[x][this.INDEX_VALNET_USED]                 = false;
        sortedBids[x][this.INDEX_VALNET_EXPIRED]              = false;
        sortedBids[x][this.INDEX_VALNET_INVALIDATED]          = false;
        sortedBids[x][this.INDEX_VALNET_SENT_CURRENTLY]       = false;
        sortedBids[x][this.INDEX_VALNET_SENT_NUMBER_OF_TIMES] = 0;
        sortedBids[x][this.INDEX_VALNET_FROM_AUCTION]         = null;
        sortedBids[x][this.INDEX_VALNET_BELONG_TO_LAST_AUCTION] = true;
    }

    this.__bidPoolAmazon = sortedBids;
};

//
// Set Prebid bids.
AdsNinjaBidsPool.prototype.addBidsPrebid = function(bids){

    if((!bids || Object.keys(bids).length === 0)){

        return;
    }

    // Combine and sort new bids with existing ones. Then add to

    var combinedBids = this.__bidPoolPrebid.concat(bids);
    var sortedBids   = Object.values(combinedBids).sort(function(bidA, bidB){

        return Math.round(1000 * bidB.cpm) - Math.round(1000 * bidA.cpm);
    });

    // Add additional fields.
    for(var x in sortedBids){

        sortedBids[x][this.INDEX_VALNET_BELONG_TO_LAST_AUCTION] = false;

        // Only add these fields to new bids.
        if(sortedBids[x].hasOwnProperty(this.INDEX_VALNET_USED)){

            continue;
        }

        sortedBids[x][this.INDEX_VALNET_USED]                   = false;
        sortedBids[x][this.INDEX_VALNET_EXPIRED]                = false;
        sortedBids[x][this.INDEX_VALNET_INVALIDATED]            = false;
        sortedBids[x][this.INDEX_VALNET_SENT_CURRENTLY]         = false;
        sortedBids[x][this.INDEX_VALNET_SENT_NUMBER_OF_TIMES]   = 0;
        sortedBids[x][this.INDEX_VALNET_FROM_AUCTION]           = null;
        sortedBids[x][this.INDEX_VALNET_BELONG_TO_LAST_AUCTION] = true;

        // Track PMPs
        if (sortedBids[x]["dealId"] && this.TRACKED_DEALS.includes(sortedBids[x]["dealId"])) {
          sortedBids[x]["adserverTargeting"]["hb_deal_bidder"] = `${sortedBids[x]["adserverTargeting"]["hb_bidder"]}_${sortedBids[x]["dealId"]}`
          sortedBids[x]["adserverTargeting"]["hb_deal_flag"] = '1';
        }
    }

    this.__bidPoolPrebid = sortedBids;

};




//
// Returns unused Prebid bids for slot.
AdsNinjaBidsPool.prototype.getUnusedBids = function(biddingLibrary, onlyFromAuctionBidder = []){

    if(false === this.BIDDING_LIBRARIES.indexOf(biddingLibrary)){

        this.__logger.error('Unknown bidding library.', {
            auctionId: this.__id,
            biddingLibrary: biddingLibrary,
        });

        return [];
    }

    var bidPool = (this.BIDDING_LIBRARY_PREBID === biddingLibrary) ? this.__bidPoolPrebid : this.__bidPoolAmazon;
    var result  = {};

    for(var adElementId in bidPool){

        for(var bid in bidPool[adElementId]){

            var bidResult = this.__determineIfBidIsUsedOrExpired(bidPool[adElementId][bid]);

            var onlyFromAuctionCheckCleared = true;

            if(window.adsNinjaHeaderBiddingManager.getBrandName() === 'TheGamer'){

                //onlyFromAuctionCheckCleared = this.__bidPassedOnlyFromAuctionCheck(bidPool[adElementId][bid], onlyFromAuctionBidder);
            }

            if(!onlyFromAuctionCheckCleared){
               
                this.__logger.debug('TTD bid not passed only from auction check.', {
                    bid: bidPool[adElementId][bid],
                });

            }
            
            bidPool[adElementId][bid] = this.__handleNewlyExpiredBid(biddingLibrary, adElementId, bidPool[adElementId][bid], bidResult);

            if(!bidResult.used && !bidResult.expired && !bidResult.invalidated && !bidResult.sentCurrently && onlyFromAuctionCheckCleared){

                bidPool[adElementId][bid][this.INDEX_VALNET_FROM_AUCTION] = this.getId(); // TODO: Fix.

                if(!result.hasOwnProperty(adElementId)){

                    result[adElementId] = [];
                }

                result[adElementId].push(bidPool[adElementId][bid]);
            }
            
            // if(bidResult.sentCurrently && this.BIDDING_LIBRARY_PREBID === biddingLibrary){

            //     // For safety make sent bids as used by Prebid.
            //     this.__pbjsMarkWinningBidAsUsed(adElementId, bidPool[adElementId][bid]);
            // }
        }
    }

    this.__logger.debug(`Unused bids.`, {
        auctionId: this.__id,
        biddingLibrary: biddingLibrary,
        bids: result,
    });

    return result;
};

//
// Returns highest unused bids for slot.
AdsNinjaBidsPool.prototype.getHighestUnusedBid = function(biddingLibrary, creativeBlacklist = [], bidderBlacklist = [], onlyFromAuctionBidder = []){

    var bids = this.__getBids(biddingLibrary);

    this.__logger.debug('Ad slot bid pool.', {
        biddingLibrary: biddingLibrary,
        bidPool: bids,
    });

    var newBlacklistedBid = null;
    for(var x in bids){

        // Only do blacklisting for video bids
        if (bids[x]['mediaType'] && bids[x]['mediaType'] === 'video') {
          // Check if creative has been blacklisted.
          var creativeId             = bids[x]['creativeId'];
          var bidder                 = bids[x]['bidder'] || bids[x]['targeting'] && bids[x]['targeting']['amznp'];
          var hasBlacklistedCreative = creativeId && creativeBlacklist.includes(String(creativeId));
          var isBlacklistedBidder = false;

          isBlacklistedBidder = bidder && bidderBlacklist.includes(String(bidder));

          if (hasBlacklistedCreative || isBlacklistedBidder) {
            // If it's not already blacklisted, blacklist it and keep track of it.
            if(!bids[x][this.INDEX_VALNET_BLACKLISTED]) {
              bids[x][this.INDEX_VALNET_BLACKLISTED] = true;
              newBlacklistedBid = bids[x];
            }
          }
        }

        var bidResult = this.__determineIfBidIsUsedOrExpired(bids[x]);

        var onlyFromAuctionCheckCleared = true;

        if(window.adsNinjaHeaderBiddingManager.getBrandName() === 'TheGamer'){
            //onlyFromAuctionCheckCleared = this.__bidPassedOnlyFromAuctionCheck(bids[x], onlyFromAuctionBidder);
        }

        if(!onlyFromAuctionCheckCleared){
               
            this.__logger.debug('TTD bid not passed only from auction check.', {
                bid: bids[x],
            });

        }


        if(!bidResult.used && !bidResult.expired && !bidResult.invalidated && !bidResult.blacklisted && !bidResult.sentCurrently && onlyFromAuctionCheckCleared){

            bids[x][this.INDEX_VALNET_SENT_CURRENTLY]       = true;
            bids[x][this.INDEX_VALNET_SENT_NUMBER_OF_TIMES] += 1;

            this.__logger.debug('Found highest bid.', {
                biddingLibrary: biddingLibrary,
                bid: bids[x],
            });

            return bids[x];
        }

        bids[x] = this.__handleNewlyExpiredBid(biddingLibrary,bids[x], bidResult);
    }

    this.__setBids(biddingLibrary, bids);

    // If we get here, there were no new good bids. Still need to return a bid to reset nobid count.
    return newBlacklistedBid;
};

//
// Check if we have bids to be used.
AdsNinjaBidsPool.prototype.hasValidBids = function(biddingLibrary){

    var bids = this.__getBids(biddingLibrary);

    var isThereBlackListedBid = false;

    for(var x in bids){

        // Only do blacklisting for video bids
        if(bids[x]['mediaType'] && bids[x]['mediaType'] === 'video'){

          if(bids[x][this.INDEX_VALNET_BLACKLISTED]) {

            isThereBlackListedBid = true;
            
          }
        }

        var bidResult = this.__determineIfBidIsUsedOrExpired(bids[x]);

        if(!bidResult.used && !bidResult.expired && !bidResult.invalidated && !bidResult.blacklisted && !bidResult.sentCurrently){

            return true;
        }
    }

    return isThereBlackListedBid;
};

//
// Marks highest bid for slot as used.
AdsNinjaBidsPool.prototype.markHighestBidAsUsed = function(biddingLibrary, invalidate = false){

    var bids = this.__getBids(biddingLibrary);

    for(var x in bids){

        var bidResult = this.__determineIfBidIsUsedOrExpired(bids[x]);

        if(bidResult.sentCurrently && !bidResult.used && !bidResult.invalidated){

            bids[x][this.INDEX_VALNET_USED]           = true;
            bids[x][this.INDEX_VALNET_SENT_CURRENTLY] = false;

            if(invalidate){

                bids[x][this.INDEX_VALNET_INVALIDATED] = true;
            }

            if(this.BIDDING_LIBRARY_PREBID === biddingLibrary){

                this.__pbjsMarkWinningBidAsUsed(bids[x]);
            }


            return true;
        }

        bids[x] = this.__handleNewlyExpiredBid(biddingLibrary,  bids[x], bidResult);
    }

    this.__setBids(biddingLibrary, bids);

    return false;
}

//
// Marks specific prebid bid for slot as used.
AdsNinjaBidsPool.prototype.markPrebidBidAsUsed = function(auctionId, adId, adElementId){

    var bids = this.__getBids(this.BIDDING_LIBRARY_PREBID);

    this.__logger.debug('Prebid bid status check: Bid information.', {
        auctionId:auctionId,
        adId:adId,
        bids: bids,
    });

    for(var x in bids){

        var bidResult = this.__determineIfBidIsUsedOrExpired(bids[x]);

        if(bids[x]['auctionId'] === auctionId && bids[x]['adId'] === adId){

            this.__logger.debug(`Prebid bid status check for adElement: ${adElementId}: Bid results.`, {
                bidResult:bidResult,
                bid: bids[x]
            });

            if(!bidResult.used && !bidResult.invalidated) {

                bids[x][this.INDEX_VALNET_USED] = true;
                bids[x][this.INDEX_VALNET_SENT_CURRENTLY] = false;

                this.__logger.debug(`Prebid bid status check for adElement: ${adElementId}, New Bid removed form the pool.`, {
                    bid: bids[x],
                });


                this.__pbjsMarkWinningBidAsUsed(bids[x]);
            }

        }


        bids[x] = this.__handleNewlyExpiredBid(this.BIDDING_LIBRARY_PREBID,  bids[x], bidResult);
    }

    this.__setBids(this.BIDDING_LIBRARY_PREBID, bids);

    return false;

};

//
// Marks specific amazon bid for slot as used.
AdsNinjaBidsPool.prototype.markPoolAmazonBidAsUsed = function(amznbid, amzniid){

    var bids = this.__getBids(this.BIDDING_LIBRARY_AMAZON);

    for(var x in bids){

        var bidResult = this.__determineIfBidIsUsedOrExpired(bids[x]);

        if(bids[x].targeting['amznbid'] === amznbid && bids[x].targeting['amzniid'] === amzniid ){

            bids[x]['status'] = 'rendered'; // Follow same convention as Prebid
            bids[x][this.INDEX_VALNET_USED] = true;
            bids[x][this.INDEX_VALNET_SENT_CURRENTLY] = false;

        }

        bids[x] = this.__handleNewlyExpiredBid(this.BIDDING_LIBRARY_AMAZON,  bids[x], bidResult);
    }

    this.__setBids(this.BIDDING_LIBRARY_AMAZON, bids);

    return false;

};


//
// Determines if bid is used or expired.
AdsNinjaBidsPool.prototype.__determineIfBidIsUsedOrExpired = function(bid){

    var ttlWithBuffer = (bid.ttl - this.TIME_TO_LIVE_BUFFER) * 1000;
    var expired       = (bid.responseTimestamp + ttlWithBuffer < Date.now());

    return {
        used: bid[this.INDEX_VALNET_USED],
        expired: expired,
        newlyExpired: (expired && !bid[this.INDEX_VALNET_EXPIRED]),
        invalidated: bid[this.INDEX_VALNET_INVALIDATED],
        sentCurrently: bid[this.INDEX_VALNET_SENT_CURRENTLY],
        blacklisted: bid[this.INDEX_VALNET_BLACKLISTED],
    };
}


//
// Handles newly expired bids.
AdsNinjaBidsPool.prototype.__handleNewlyExpiredBid = function(biddingLibrary, bid, bidResult){

    if(bidResult.newlyExpired){

        this.__logger.debug('Expired bid.', {
            biddingLibrary: biddingLibrary,
            bid: bid,
        });

        bid[this.INDEX_VALNET_EXPIRED] = true;
    }

    return bid;
}

//
// Need to also mark this for Prebid otherwise it could possibly get reused if these methods return not highest bid.
AdsNinjaBidsPool.prototype.__pbjsMarkWinningBidAsUsed = function(bid){

    if(!window.pbjs || typeof window.pbjs.markWinningBidAsUsed !== 'function'){

        return;
    }

    var winningBidData = {
        adUnitCode: bid.adUnitCode,
    };

    if(bid.hasOwnProperty('adId')){

        winningBidData['adId'] = bid.adId;
    }

    // TODO: Don't do this here?
    window.pbjs.markWinningBidAsUsed(winningBidData);
}




//
// Returns bids for slot.
AdsNinjaBidsPool.prototype.__getBids = function(biddingLibrary){

    if(false === this.BIDDING_LIBRARIES.indexOf(biddingLibrary)){

        this.__logger.error('Unknown bidding library.', {
            biddingLibrary: biddingLibrary,
        });

        return [];
    }

    if(this.BIDDING_LIBRARY_AMAZON === biddingLibrary){

        return this.__bidPoolAmazon || [];
    }

    return this.__bidPoolPrebid || [];
};

//
// Sets bids for slot.
AdsNinjaBidsPool.prototype.__setBids = function(biddingLibrary, bids){

    if(false === this.BIDDING_LIBRARIES.indexOf(biddingLibrary)){

        this.__logger.error('Unknown bidding library.', {
            biddingLibrary: biddingLibrary,
        });

        return;
    }

    if(this.BIDDING_LIBRARY_AMAZON === biddingLibrary){

        return this.__bidPoolAmazon = bids;
    }

    return this.__bidPoolPrebid = bids;
};

//
// Sets bid that was sent currently to the ad server to be reusable.
AdsNinjaBidsPool.prototype.allowBidToBeReused = function(auctionId, adId, adElementId, biddingLibrary){

    this.__logger.debug(`${biddingLibrary} bid status check: Bid information.`, {
        auctionId: auctionId,
        adId: adId,
        bids: bids,
    });

    var bids = this.__getBids(biddingLibrary);

    for(var x in bids){

        var bidResult = this.__determineIfBidIsUsedOrExpired(bids[x]);

        if(bids[x].auctionId === auctionId && bids[x].adId === adId){

            this.__logger.debug(`${biddingLibrary} bid status check for adElement: ${adElementId}: Bid results.`, {
                bidResult:bidResult,
                bid: bids[x]
            });

            if(bidResult.sentCurrently && !bidResult.used && !bidResult.invalidated){
                bids[x][this.INDEX_VALNET_SENT_CURRENTLY] = false;

                this.__logger.debug(`${biddingLibrary} bid status check for adElement: ${adElementId}, Bid reintroduced in the pool.`, {
                    bid: bids[x],
                });
            }

        }

        bids[x] = this.__handleNewlyExpiredBid(biddingLibrary,  bids[x], bidResult);
    }

    this.__setBids(biddingLibrary, bids);

    return false;
}

AdsNinjaBidsPool.prototype.addNewValidSizes = function(newSizes) {

    for(var x in newSizes) {

        var size = {};

        size['width'] = newSizes[x][0];
        size['height'] = newSizes[x][1];

        var sizeKey = size['width'] + 'x' + size['height'];

        this.validAdSizes[sizeKey] = size;
    }

}

AdsNinjaBidsPool.prototype.getValidSizes = function() {

    return this.validAdSizes;
}

//
// Returns the combined size of the pool.
AdsNinjaBidsPool.prototype.getSize = function(){

    return this.__bidPoolPrebid.length + this.__bidPoolAmazon.length;
};

//
// Returns the prebid pool size.
AdsNinjaBidsPool.prototype.getPrebidSize = function(){

    return this.__bidPoolPrebid.length;
};

//
// Returns the amazon pool size.
AdsNinjaBidsPool.prototype.getAmazonSize = function(){

    return this.__bidPoolAmazon.length;
};


AdsNinjaBidsPool.prototype.__bidPassedOnlyFromAuctionCheck = function(bid, onlyFromAuctionBidder = []){

    if(!onlyFromAuctionBidder.includes(bid['bidderCode'])){

        return true;
    }

    return bid[this.INDEX_VALNET_BELONG_TO_LAST_AUCTION];
}

window.AdsNinjaBidsPool = AdsNinjaBidsPool;
